// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"styles_rectangle__8N0Vh","hovered":"styles_hovered__19mt5","feView__rectangle":"styles_feView__rectangle__2QQSe","feViewRectangle":"styles_feView__rectangle__2QQSe"};